import { IAppContext } from 'App/AppContext';
import { TFunction } from 'i18next';
import { StoreMgmtStates } from 'models/adminTenant';
import Task, { TaskTypes } from 'models/tasks/task';
import { FeatureTypes, hasUserFeature } from 'services/Auth/featurePermissions';

// Rules shared by the task detail fields and the task detail panel.

// The shared with / schema field needs the RBAC feature
export const canShowTaskSchema = (appContext: IAppContext): boolean => hasUserFeature(appContext, FeatureTypes.RBAC);

export const getTaskSchemaName = (task: Task, appContext: IAppContext, t: TFunction<string[]>): string =>
  appContext.globalDataCache.authSchemas.get(task.authSchemaId).name || t('adminAuth:AuthSchemaPicker.Placeholder');

// A repeating task is a monitoring task (TASK0015): a Normal task shows no recurrence, except an existing legacy
// series, which shows its pattern read-only
export const isLegacyNormalSeries = (task: Task): boolean =>
  task.taskType === TaskTypes.Normal && task.recurringPattern.isActive;

export const canShowTaskRecurrence = (task: Task): boolean =>
  !(task.taskType === TaskTypes.Normal && !isLegacyNormalSeries(task));

// The task to open the recurrence dialog with: the recurrence starts from the planned start date
export const getTaskForRecurrenceDialog = (task: Task): Task => {
  const copyTask = task.clone();
  copyTask.recurringPattern.startDate = copyTask.startDateTime;

  return copyTask;
};

// The external id is only editable/visible for creators (store management mode)
export const canShowTaskExternalId = (appContext: IAppContext): boolean =>
  appContext.user.login.storeMgmtState === StoreMgmtStates.Creator;

export const getTaskDeadlineLabel = (task: Task, t: TFunction<string[]>): string =>
  task.isRecurring() ? t('task:Deadline.LabelRecurring') : t('task:Deadline.Label');
